module.exports = __webpack_public_path__ + "static/media/topo-fale-com-anage-imoveis.df8ed851.webp";